import React, { useState, useEffect } from 'react';
import developerImage from '../assets/images/devloper.png';
import hamburgerIcon from '../assets/images/ham.svg';
import closeIcon from '../assets/images/close.svg';
import Typed from 'typed.js'; // Import Typed.js if using npm

const Home = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    

    useEffect(() => {
        const typed = new Typed('#typing-text', {
            strings: [
                "Web Developer...",
                "Backend Developer..",
                "Software Engineer...",
                "Problem Solver...",
            ],
            typeSpeed: 50,
            backSpeed: 50,
            backDelay: 1500,
            startDelay: 100,
            loop: true,
        });

        // Cleanup function to destroy Typed.js instance when component unmounts
        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <div>
            {/* Sidebar */}
            <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    {/* Only show the close button when the sidebar is open */}
                    {isSidebarOpen && (
                        <img
                            src={closeIcon}
                            alt="Close Sidebar"
                            className="close-btn"
                            onClick={toggleSidebar}
                        />
                    )}
                </div>
                <ul className="sidebar-links">
                    <li><a href="/" onClick={toggleSidebar}>Home</a></li>
                    <li><a href="/about" onClick={toggleSidebar}>About</a></li>
                    <li><a href="/skills" onClick={toggleSidebar}>Skills</a></li>
                    <li><a href="/projects" onClick={toggleSidebar}>Projects</a></li>
                    <li><a href="/contact" onClick={toggleSidebar}>Contact</a></li>
                </ul>
            </div>

            {/* Hamburger Menu - Show when sidebar is closed */}
            {!isSidebarOpen && (
                <img
                    src={hamburgerIcon}
                    alt="Open Sidebar"
                    className="hamburger"
                    onClick={toggleSidebar}
                />
            )}

            {/* Header */}
            <header>
                <nav className="navbar">
                    <div className="left">
                        <a href="/" className="portfolio-link">
                            <span className="purple">P</span>rem Portfolio
                        </a>
                    </div>
                    <div className="right ml-auto">
                        <ul className="navbar-nav">
                            <li className="nav-item"><a className="nav-link" href="/about">About</a></li>
                            <li className="nav-item"><a className="nav-link" href="/skills">Skills</a></li>
                            <li className="nav-item"><a className="nav-link" href="/projects">Projects</a></li>
                            <li className="nav-item"><a className="nav-link" href="/contact">Contact</a></li>
                        </ul>
                    </div>
                </nav>
            </header>

            {/* Main Content */}
            <main>
                <section className="firstSection">
                    <div className="leftSection">
                        Hi, My name is<span className="purplee">Prem</span>
                        <div> and I am a passionate </div>
                        <span className="purplee" id="typing-text"></span>


                        <div className="button">
                            <button className="btn">
                                <a href={require('../assets/documents/Prem.pdf')} download="Prem_Resume">Download Resume</a>
                            </button>
                            <button className="btn">
                                <a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer">Visit Github</a>
                            </button>
                        </div>
                    </div>
                    <div className="rightSection">
                        <img src={developerImage} alt="developer" />
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer>
                <div className="footer">
                    <div className="first">
                        <h3>Prem's Developer Portfolio</h3>
                        <p>Building innovative solutions for the web, one project at a time.</p>
                    </div>
                    <div className="second">
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About</a></li>
                            <li><a href="/skills">Skills</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>
                    <div className="third">
                        <h4>Connect with me:</h4>
                        <ul>
                            <li>
                                <a href="https://github.com/itachiuchiha241" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-github"></i> GitHub
                                </a>
                            </li>
                            <li>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-linkedin"></i> LinkedIn
                                </a>
                            </li>
                            <li>
                                <a href="mailto:prempawar241@gmail.com">
                                    <i className="fas fa-envelope"></i> Email Me
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-rights">
                    <p className="mb-0">&copy; 2025 Prem's Portfolio. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home;
